import { BaseEverplansStatus } from '@/classes/SubmissionStatuses/BaseEverplansStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { getEverplansTierText } from '@/classes/SubmissionStatuses/statusUtils'

export class ManuallyResolvedStatus extends BaseEverplansStatus {
	getStatusText() {
		return this.submissionStatus.requestedAccountTier
			? getEverplansTierText(this.submissionStatus.requestedAccountTier) +
					' / Manually Resolved'
			: 'Manually Resolved'
	}

	getToolTipText() {
		return {
			title: this.getStatusText(),
			body:
				'This Everplans Submission has been manually resolved. ' +
				'Have questions? Contact salesstudio@precoa.com.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.SUCCESS
	}
}
